import { Http } from '../axios/interceptors'

export const allMembershipsOfcompany = async (guid) => Http('GET', `/SubscriptionsCompanies/Get?guidCompany=${guid}`)

export const allCompanyMemberships = async (param) => Http('GET', `/SubscriptionsCompanies/GetList?`, param)

export const editMembership = async (body) => Http('PUT', `/SubscriptionsCompanies/Update`, null, body)

export const registerPaymentSubcription = async (body) =>  Http('POST', '/SubscriptionsCompanies/CreatePayment', null, body)

export const confirmatedPaymentSubcription = async (body) =>  Http('POST', '/SubscriptionsCompanies/ConfirmatedPayment', null, body)

export const allCompanyListPayments = async (param) => Http('GET', `/SubscriptionsCompanies/GetListPayments?`, param)

export const getPayment = async (guid) => Http('GET', `/SubscriptionsCompanies/GetPaymentId?idSubscriptionPayment=${guid}`)

export const getInvoice = async (idSubscriptionPaymen) => Http('GET', `/SubscriptionsCompanies/GetPaymentPDF?idSubscriptionPayment=${idSubscriptionPaymen}`)

// export const deleteSubcription = async guid => Http('DELETE', `/Subscriptions/Delete?guid=${guid}`)